import React, { useId, useState, useContext } from "react"
import { DataContext } from "../../DataContext";
import { PropertyEditor } from "../../window/PropertyEditor"
import { PropertyInput } from "../../components/PropertyInput";
import { Calendar } from "primereact/calendar";
import gtfsFormatDate, { gtfsFormatDateToYYYYMMDD, gtfsParseYYYYMMDD } from "../../helpers/gtfsDateUtils";
import { SelectButton } from "primereact/selectbutton";
import { ListBox } from "primereact/listbox";
import { PropertySwitch } from "../../components/PropetySwitch";
import { PropertyCheckbox } from "../../components/PropertyCheckbox";
import { PropertyDropdown } from "../../components/PropertyDropdown";
import { DateExceptionPropertyListbox } from "../../components/DateExceptionPropertyListobx";
import React from "react";
import { useMutateGtfsResource, useQueryGtfsResource } from "../../Queries";
import React from "react";
import { OverlayContext } from "../../OverlaysContext";

export function CalendarPropertyEditor({GCalendar}) {
    const header = (
        <>
            <span className='text-200 text-sm'>{GCalendar.service_id}</span> {GCalendar.service_description}
        </>
    )

    return (
        <PropertyEditor resourceTable='calendars' selectedItemId={GCalendar.service_id} header={header}  >
            <CalendarPropertiesForm></CalendarPropertiesForm>
        </PropertyEditor>
    )
}

function CalendarPropertiesForm() {
    const id = useId();
    const data = useContext(DataContext);
    const modifyCalendar = useMutateGtfsResource();
    const [modifiedValues, setModifiedValues] = useState(data.inputValues);
    const [validationErrors, setValidationErrors] = useState(false);
    const [isMutationPending, setIsMutationPending] = useState(false);
    const handleOverlays = useContext(OverlayContext);
    const {data: calendarList, isPending, error} = useQueryGtfsResource('calendars');

    const weekSelectorValues = [];
    if(data.inputValues.monday === true) { weekSelectorValues.push('monday')}
    if(data.inputValues.tuesday === true) { weekSelectorValues.push('tuesday')}
    if(data.inputValues.wednesday === true) { weekSelectorValues.push('wednesday')}
    if(data.inputValues.thursday === true) { weekSelectorValues.push('thursday')}
    if(data.inputValues.friday === true) { weekSelectorValues.push('friday')}
    if(data.inputValues.saturday === true) { weekSelectorValues.push('saturday')}
    if(data.inputValues.sunday === true) { weekSelectorValues.push('sunday')}

    let dateAddedValues = [];
    let dateRemovedValues = [];
    dateAddedValues = data.inputValues.exceptions_dates_added.map(
        (x) => { return {option: gtfsFormatDate(x), value: x} }
    );

    dateRemovedValues = data.inputValues.exceptions_dates_removed.map(
        (x) => { return {option: gtfsFormatDate(x), value: x} }
    );

    function handleInput(propertyName,value) {
        let newValues = {...modifiedValues};
        newValues[propertyName] = value;
        setModifiedValues(newValues);
    }

    function handleInputCancel() {
        setModifiedValues(data.inputValues);
    }

    console.log('Mutation object:', modifyCalendar);
    console.log('Mutation mutate function:', modifyCalendar.mutateAsync);
      
    /* TODO: refaktoryzacja "handleInputDone" wszędzie, we wszystkich formularzach.
        Być może wcale nie potrzebujemy tak złożonej funkcji, która powtarza się we wszystkich
        formularzach i zawsze jest funckją asynchroniczną z optymistyczną aktualizacją,
        która powoduje trochę błędów i jest trudna w debugowaniu.


        Sprawdźmy, czy możemy stowrzyć jedną funkcję "handleSimpleInputDone" opartą na zwykłej
        mutacji, bez tego asynchronicznego pierdololo. Edycja przystanków wymaga wprawdzie
        edycji optymistycznej. Ale tutaj może to niepotrzebne. Zwłaszcza, że optymistyczna
        aktualizacja przerywa nam renderowanie komponentu z listboxem po lewej i resetuje go
        do początkowej pozycji... bezsęs
        
        */
    async function handleInputDone(propertyName, value) {


        if(value === data.inputValues[propertyName]) {
            return; // Nie wysyłamy zmian na serwer, jeżeli nowa wartość jest taka jak już zapisana do serwera.
        }

        const payload = {
            query: {
              modified_id: String(data.inputValues.service_id),
              resourceTable: 'calendars'
            },
            fields: {}
          };
          payload.fields[propertyName] = value;
          setIsMutationPending(true);
          try {
            console.log('Calling mutation.mutate with payload',payload);
            const asyncMutation = await modifyCalendar.mutateAsync(payload).then(() => console.log('Mutation finished') );  // próbujemy przeprowadzić mutację

            // wykasuj ewentualne istniejące błędy walidacji z UI, skoro wszystko poszło ok
            if(validationErrors[propertyName]) {
                let updatedValidationErrors = {...validationErrors};
                updatedValidationErrors[propertyName] = false;
                setValidationErrors({
                    ...updatedValidationErrors
                });                   
            } 
        } catch(error) {
            const errorCode = error.message.slice(0,3);
            if(errorCode == '422') {
                //obsługa błędów walidacji
                let updatedValidationErrors = {...validationErrors};
                updatedValidationErrors[propertyName] = Object.values(error.cause.validation[propertyName]).join(', ');
                setValidationErrors({
                    ...updatedValidationErrors
                });
            } else {
                //obsługa pozostałych błędów
                handleOverlays('toast',{
                    severity: "error",
                    summary: 'Błąd ' + errorCode,
                    detail: (typeof error.cause === 'undefined' || typeof error.cause.message === 'undefined') ? 'Wystąpił błąd. Czynność nie mogła zostać zakończona powodzeniem. ' + error.message : error.cause.message
                });
                console.log(error);
            }

        } finally {
            setIsMutationPending(false);
        }
    }

    return (
        <div className="formgrid grid">
            <div className="field col-4">
                <PropertyInput 
                    propertyName='service_id'
                    label='Oznaczenie kalendarza'
                    id={id}
                    value={modifiedValues.service_id}
                    initialVal={data.inputValues.service_id}
                    onDone={handleInputDone}
                    onChange={handleInput}
                    onCalcel={handleInputCancel}
                    pending={isMutationPending}
                />
            </div>
            <div className="field col-4">
                <label htmlFor={id+'_start_date'}>Ważny od:</label>
                <Calendar inputId={id+'_start_date'}
                    value={gtfsParseYYYYMMDD(modifiedValues.start_date)}
                    dateFormat="dd.mm.yy"
                    onChange={(e) => {
                        let newValues = {...modifiedValues};
                        newValues['start_date'] = gtfsFormatDateToYYYYMMDD(e.value);
                        setModifiedValues(newValues);   // tzw. (trochę) optymistyczna aktualizacja...
                        handleInputDone('start_date',gtfsFormatDateToYYYYMMDD(e.value));
                    }}
                    onHide={ () => {console.log('todo: input done')} }
                />
            </div>
            <div className="field col-4">
                <label htmlFor={id+'_end_date'}>Ważny od:</label>
                <Calendar inputId={id+'_end_date'}
                    value={gtfsParseYYYYMMDD(modifiedValues.end_date)}
                    dateFormat="dd.mm.yy"
                    onChange={(e) => {
                        let newValues = {...modifiedValues};
                        newValues['end_date'] = gtfsFormatDateToYYYYMMDD(e.value);
                        setModifiedValues(newValues);   // tzw. (trochę) optymistyczna aktualizacja...
                        handleInputDone('end_date',gtfsFormatDateToYYYYMMDD(e.value));
                    }}
                    onHide={ () => {console.log('todo: input done')} }
                />
            </div>
            <div className="field col-12">
                <label htmlFor={id + '_week_selector'}>Dni tygodnia, w których kurs jest wykonywany wg tego kalendarza:</label>
                <div className="flex justify-content-center">
                    <SelectButton multiple
                        id={id + '_week_selector'}
                        optionLabel="name"
                        optionValue="value"
                        options={[
                            {name: 'PON.', value: 'monday'},
                            {name: 'WTO.', value: 'tuesday'},
                            {name: 'ŚRO.', value: 'wednesday'},
                            {name: 'CZW.', value: 'thursday'},
                            {name: 'PIĄ.', value: 'friday'},
                            {name: 'SOB.', value: 'saturday'},
                            {name: 'NIE.', value: 'sunday'},
                        ]}
                        value={weekSelectorValues}
                        onChange={(e) => {
                            handleInputDone('weekdays',e.value)
                        }}
                    />
                </div>
            </div>
            <h2 className="col-12 mt-5">Wyjątki w kursowaniu (np. święta)</h2>
            <div className="field col-5">      
                <DateExceptionPropertyListbox 
                    id={id}
                    icon="fa-solid fa-calendar-plus"
                    propertyName='exceptions_date_added'
                    options={dateAddedValues}
                    optionLabel="option"
                    optionValue="value"
                    label="Kursuje dodatkowo w dni:"
                    emptyMessage="(brak wyjątków)"
                    minDate={gtfsParseYYYYMMDD(data.inputValues.start_date)}
                    maxDate={gtfsParseYYYYMMDD(data.inputValues.end_date)}
                    onDone={handleInputDone}
                />
            </div>
            <div className="field col-2">

            </div>
            <div className="field col-5">
            <DateExceptionPropertyListbox 
                    id={id}
                    icon="fa-solid fa-calendar-minus"
                    propertyName='exceptions_date_removed'
                    options={dateRemovedValues}
                    optionLabel="option"
                    optionValue="value"
                    label="Nie kursuje w dni:"
                    emptyMessage="(brak wyjątków)"
                    minDate={gtfsParseYYYYMMDD(data.inputValues.start_date)}
                    maxDate={gtfsParseYYYYMMDD(data.inputValues.end_date)}
                    onDone={handleInputDone}
                />
            </div>

            <h2 className="col-12 mt-5">Objaśnienia kalendarza</h2>
            <div className="field col-12">
                <PropertyInput 
                        propertyName='service_description'
                        label='Pełne objaśnienie kalendarza'
                        id={id}
                        value={modifiedValues.service_description}
                        initialVal={data.inputValues.service_description}
                        onDone={handleInputDone}
                        onChange={handleInput}
                        onCancel={handleInputCancel}
                        pending={isMutationPending}
                />
            </div>
            <div className="field col-12">
                <PropertyCheckbox
                    label='Objaśnienie widoczne w legendzie na tabliczkach rozkładowych'
                    propertyName='service_description_display'
                    id={id}
                    value={modifiedValues.service_description_display}
                    initialVal={data.inputValues.service_description_display}
                    onDone={handleInputDone}
                    pending={isMutationPending}
                />
            </div>
            {
                (data.inputValues.service_description_display) ?
                 <>
                    <div className="field col-12">
                        <PropertyInput 
                                propertyName='service_description_table'
                                label='Objaśnienie kalendarza na tabliczki rozkładowe'
                                id={id}
                                value={modifiedValues.service_description_table}
                                initialVal={data.inputValues.service_description_table}
                                onDone={handleInputDone}
                                onChange={handleInput}
                                onCalcel={handleInputCancel}
                                pending={isMutationPending}
                        />
                    </div>
                        {
                            (Array.isArray(calendarList) && !error && !isPending) ?
                                <div className="field col-12">
                                    <PropertyDropdown
                                        showClear={true}
                                        label='Przy objaśnieniach traktuj ten kalendarz jako wyjątek od'
                                        id={id}
                                        propertyName='service_parent'
                                        options={calendarList}
                                        optionValue='service_id'
                                        optionLabel='service_id'
                                        itemTemplate={(option) => option.service_id + ' - ' + option.service_description}
                                        valueTemplate={(option, props) => (option) ? option.service_id + ' - ' + option.service_description : props.placeholder}
                                        initialVal={data.inputValues.service_parent}
                                        onDone={handleInputDone}
                                    />
                                </div> : <></>

                        }

                 </>
                :
                <></>
            }

        </div>
    );
}